<template>
  <v-card class="single-question">
    <ct-loading ref="loader" global>
      <span class="small-loader" slot="loader">
        <span class="loading"></span>
      </span>
    </ct-loading>
  <div :key="question.question_id">
  <question-status
    :id="question.question_id"
    :interesting="question.interesting"
    :is-right="!!question.is_right"
    :useful="question.top"
    :module="question.tags||[]"
    :self_interesting="question.self_interesting"
    :self_useful="question.self_top"
    :index="questionIndex + 1"
    @update-question="handelUpdateQuestion"
    ></question-status>
    <question-pre-conditions :html-head="html_head"></question-pre-conditions>
    <div v-for="(item, i) in html_subquestion" :key="i">
      <sub-questions
      :sub="item.sub"
      :subquestionLength="html_subquestion.length"
      :visible-right-answer="visibleRightAnswer"
      :index="i"
      :result_unit="item.result_unit"
      :options="item.options||[]"
      :question_type="question_type[i]"
      :user_answer="user_answer[i]|| {}"
      :right_answer="right_answer[i]"
      ></sub-questions>
    </div>
    <question-constants :parameters="html_parameters"></question-constants>
    <analysis-answer
      v-show="visibleRightAnswer"
      :analysis="html_analysis.analysis"
      :answer="html_analysis.answer"
      v-if="html_analysis"></analysis-answer>
    </div>

  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import VCard from '@ca/components/Card'
import {
  AnalysisAnswer,
  QuestionConstants,
  SubQuestions,
  QuestionPreConditions,
  QuestionStatus
} from '@ca/components/question'
import { scrollPageByClass } from '@/utils'
import { $loadMathjax, $MathJaxHub } from '@/utils/question'
import { questionType } from '@ca/constants'
import { globalMixin } from '@ca/mixins'

export default {
  name: 'SingleQuestion',
  components: {
    'v-card': VCard,
    'analysis-answer': AnalysisAnswer,
    'question-constants': QuestionConstants,
    'sub-questions': SubQuestions,
    'question-pre-conditions': QuestionPreConditions,
    'question-status': QuestionStatus
  },
  props: {
    questionList: Array,
    index: {
      type: Number
    },
    visibleRightAnswer: {
      type: Boolean,
      default: true
    }
  },
  mixins: [globalMixin],
  data () {
    return {
    }
  },
  watch: {
    visibleRightAnswer () {
      this.$nextTick(() => {
        $MathJaxHub('single-question-page')
      })
    },
    questionIndexMap (value) {
      if (this.index !== null && this.index !== undefined && this.index >= 0) {
        this.updateQuestionIndex(this.index)
      }
    },
    question (value) {
      this.$nextTick(() => {
        $MathJaxHub('single-question-page')
        this.hideLoading(this.$refs.loader)
      })
      if (value.question_id) {
        this.changeDomTitle({ title: `ID ${value.question_id} | Course System` })
      }
    },
    dispatchingMultiQuestions (value) {
      this.$nextTick(() => {
        if (value) {
          this.showLoading()
        } else {
          this.hideLoading(this.$refs.loader)
        }
      })
    }
  },
  computed: {
    ...mapGetters(['question', 'dispatchingMultiQuestions', 'subquestionIndex', 'questionIndex', 'questionIndexMap']),
    html_head () {
      return this.question.html_head
    },
    html_subquestion () {
      if (this.question.html_subquestion) {
        return this.question.html_subquestion.map(item => {
          return Object.assign({}, item)
        })
      }
      return []
    },
    html_parameters () {
      return this.question.html_parameters
    },
    html_analysis () {
      return this.question.html_analysis
    },
    right_answer () {
      return this.question.right_answer || []
    },
    user_answer () {
      return this.question.user_answer || []
    },
    question_type () {
      return this.question.question_type || []
    }
  },
  methods: {
    ...mapActions(['updateQuestion', 'updateSubquestionIndex', 'updateQuestionIndex', 'updateQuestionList', 'clearQuestion', 'changeDomTitle']),
    handelUpdateQuestion (data) {
      this.updateQuestion(data)
    },
    showLoading () {
      this.$refs.loader.open()
    },
    focusSubquestion (index) {
      if (index >= 0 && index < this.question.html_subquestion.length) {
        this.updateSubquestionIndex(index)
        this.$nextTick(() => {
          scrollPageByClass(`subquestion-${index}`, {
            behavior: 'smooth',
            block: 'center'
          })
        })
      }
    },
    addEvent () {
      if (document.addEventListener) {
        document.addEventListener('keyup', this.handleKeyup)
      }
    },
    handleKeyup (event) {
      if (document.body.style.overflow === 'hidden') {
        return false
      }
      const isUp = event.keyCode === 38
      const isDown = event.keyCode === 40
      if (event.shiftKey && isDown) {
        this.focusSubquestion(this.subquestionIndex + 1)
      }
      if (event.shiftKey && isUp) {
        this.focusSubquestion(this.subquestionIndex - 1)
      }
    },
    removeEvent () {
      if (document.removeEventListener) {
        document.removeEventListener('keyup', this.handleKeyup)
      }
    }
  },
  mounted () {
    this.updateQuestionList({
      questionList: this.questionList,
      question_type: questionType[this.$route.path.split('/')[1]],
      questionIndex: this.index
    })

    this.$nextTick(() => {
      $loadMathjax()
      if (window.MathJax) {
        $MathJaxHub('single-question-page')
      }
    })
    this.addEvent()
    if (document.querySelector('.ct-footer')) {
      document.querySelector('.ct-footer').style.display = 'none'
    }
  },
  destroyed () {
    this.removeEvent()
    this.clearQuestion()
    if (document.querySelector('.ct-footer')) {
      document.querySelector('.ct-footer').style.display = 'block'
    }
    this.hideLoading(this.$refs.loader)
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
@import '@/styles/_loader.scss';
.single-question{
  padding: 16px 0 32px;
  margin-right:327px;
  margin-bottom: 60px;
  // position: relative;
}
</style>
